import {
  RedInvoiceEntryItem,
  RedInvoiceReturnDetail,
  ReturnOrderDetailVo,
} from '@/api/orderManage'
import { FRONT_KEY } from '@/global/config'
import { bigCalc, generateUUID } from '@xhgj/xh-jsutils'
import { pick } from 'lodash'

export type ReturnOrderDetailItem = Partial<
  Pick<
    RedInvoiceEntryItem,
    | 'orderNo'
    | 'returnNo'
    | 'titleOfTheContract'
    | 'returnTime'
    // | 'blueInvoiceNum'
    | 'taxRate'
  >
> &
  Pick<
    RedInvoiceReturnDetail,
    'productCode' | 'manuCode'
    // | 'productPrice'
    // | 'returnNum'
  > & {
    deliveryDetailId?: string
    totalAmountIncludingTax?: number
    totalAmount?: number
    totalTaxAmount?: number
    productPrice?: number
    returnNum?: number
    // blueInvoiceNum:string
  } & Record<string, any>

function joinRedReturnDetailListKey(options: {
  item: RedInvoiceEntryItem
  detail: RedInvoiceReturnDetail
}) {
  const { item, detail } = options || {}
  return `${item.id}-${detail.deliveryDetailId}`
}

/**
 * 转换红票列表接口到退货明细
 * @param itemList
 * @returns
 */
export function convertToReturnOrderDetailItemList(
  itemList: RedInvoiceEntryItem[],
): ReturnOrderDetailItem[] {
  const res: ReturnOrderDetailItem[] = []
  for (const item of itemList) {
    const detailList = item.returnDetailList || []
    const totalAmountIncludingTax = bigCalc
      .sumListByFieldNameBig(detailList, 'totalAmountIncludingTax')
      .toNumber()
    detailList.forEach((detail, index) => {
      const isFirst = index === 0
      const commonFields = ['blueInvoiceNum', 'taxRate', 'returnAmount', 'id']
      const forntFields = isFirst
        ? pick(item, [
            'orderNo',
            'returnNo',
            'returnTime',
            'titleOfTheContractName',
            ...commonFields,
          ])
        : (pick(item, commonFields) as any)
      const totalAmount = detail.returnNum
      res.push({
        [FRONT_KEY]: joinRedReturnDetailListKey({ item, detail }),
        id: detail.deliveryDetailId,
        hideCheckbox: !isFirst,
        ...forntFields,
        titleOfTheContract: item.titleOfTheContractName,
        titleOfTheContractName: item.titleOfTheContractName,
        productCode: detail.productCode || '',
        productName: detail.productName || '',
        manuCode: detail.manuCode || '',
        productPrice: detail.productPrice || 0,
        returnNum: detail.returnNum || 0,
        totalAmount: detail.totalAmount,
        // 合计税额
        totalTaxAmount: detail.totalTaxAmount,
        totalAmountIncludingTax: detail.totalAmountIncludingTax,
      })
    })
  }
  return res
}

/**
 * 红票退货明细删除时，要根据订单id来删除
 * @param list
 * @param selectedRowKeys
 */
export function collectRedDelId(list: any, selectedRowKeys: any[]) {
  const delList = []
  for (const item of list) {
    if (selectedRowKeys.includes(item?.[FRONT_KEY])) {
      delList.push(item)
    }
  }
  const delOrderList = delList.map((item) => {
    return item.id
  })
  return delOrderList
}
/**
 * 详情接口中转换退货单明细
 * @param itemList
 * @returns
 */
export function convertDetailToReturnOrderDetailItemList(
  itemList: ReturnOrderDetailVo[],
) {
  const res: ReturnOrderDetailItem[] = []
  const returnNoMap = new Map<string, boolean>() // 用于记录退货单号是否已出现

  itemList.forEach((detail, index) => {
    const returnNo = detail.returnOrderNo ?? ''
    const isFirst = !returnNoMap.has(returnNo)

    if (isFirst) {
      returnNoMap.set(returnNo, true)
    }

    res.push({
      [FRONT_KEY]: generateUUID(),
      id: detail.returnOrderId,
      hideCheckbox: !isFirst,
      orderNo: isFirst ? (detail.orderNo ?? '') : undefined,
      returnNo: isFirst ? returnNo : undefined,
      titleOfTheContract: isFirst ? detail.titleOfTheContract : undefined,
      titleOfTheContractName: isFirst ? detail.titleOfTheContract : undefined,
      returnTime: isFirst ? detail.returnTime : undefined,
      taxRate: detail.taxRate,
      productCode: detail.productCode || '',
      productName: detail.productName || '',
      manuCode: detail.model || '',
      productPrice: detail.price,
      returnNum: detail.returnNum,
      totalAmountIncludingTax: detail.totalAmountIncludingTax,
      totalAmount: detail.totalAmount,
      totalTaxAmount: detail.totalTaxAmount,
    })
  })

  return res
}
import {
  RedInvoiceEntryItem,
  RedInvoiceReturnDetail,
  ReturnOrderDetailVo,
} from '@/api/orderManage'
import { FRONT_KEY } from '@/global/config'
import { bigCalc, generateUUID } from '@xhgj/xh-jsutils'
import { pick } from 'lodash'

export type ReturnOrderDetailItem = Partial<
  Pick<
    RedInvoiceEntryItem,
    | 'orderNo'
    | 'returnNo'
    | 'titleOfTheContract'
    | 'returnTime'
    // | 'blueInvoiceNum'
    | 'taxRate'
  >
> &
  Pick<
    RedInvoiceReturnDetail,
    'productCode' | 'manuCode'
    // | 'productPrice'
    // | 'returnNum'
  > & {
    deliveryDetailId?: string
    totalAmountIncludingTax?: number
    totalAmount?: number
    totalTaxAmount?: number
    productPrice?: number
    returnNum?: number
    // blueInvoiceNum:string
  } & Record<string, any>

function joinRedReturnDetailListKey(options: {
  item: RedInvoiceEntryItem
  detail: RedInvoiceReturnDetail
}) {
  const { item, detail } = options || {}
  return `${item.id}-${detail.deliveryDetailId}`
}

/**
 * 转换红票列表接口到退货明细
 * @param itemList
 * @returns
 */
export function convertToReturnOrderDetailItemList(
  itemList: RedInvoiceEntryItem[],
): ReturnOrderDetailItem[] {
  const res: ReturnOrderDetailItem[] = []
  for (const item of itemList) {
    const detailList = item.returnDetailList || []
    const totalAmountIncludingTax = bigCalc
      .sumListByFieldNameBig(detailList, 'totalAmountIncludingTax')
      .toNumber()
    detailList.forEach((detail, index) => {
      const isFirst = index === 0
      const commonFields = ['blueInvoiceNum', 'taxRate', 'returnAmount', 'id']
      const forntFields = isFirst
        ? pick(item, [
            'orderNo',
            'returnNo',
            'returnTime',
            'titleOfTheContractName',
            ...commonFields,
          ])
        : (pick(item, commonFields) as any)
      const totalAmount = detail.returnNum
      res.push({
        [FRONT_KEY]: joinRedReturnDetailListKey({ item, detail }),
        id: detail.deliveryDetailId,
        hideCheckbox: !isFirst,
        ...forntFields,
        titleOfTheContract: item.titleOfTheContractName,
        titleOfTheContractName: item.titleOfTheContractName,
        productCode: detail.productCode || '',
        productName: detail.productName || '',
        manuCode: detail.manuCode || '',
        productPrice: detail.productPrice || 0,
        returnNum: detail.returnNum || 0,
        totalAmount: detail.totalAmount,
        // 合计税额
        totalTaxAmount: detail.totalTaxAmount,
        totalAmountIncludingTax: detail.totalAmountIncludingTax,
      })
    })
  }
  return res
}

/**
 * 红票退货明细删除时，要根据订单id来删除
 * @param list
 * @param selectedRowKeys
 */
export function collectRedDelId(list: any, selectedRowKeys: any[]) {
  const delList = []
  for (const item of list) {
    if (selectedRowKeys.includes(item?.[FRONT_KEY])) {
      delList.push(item)
    }
  }
  const delOrderList = delList.map((item) => {
    return item.id
  })
  return delOrderList
}
/**
 * 详情接口中转换退货单明细
 * @param itemList
 * @returns
 */
export function convertDetailToReturnOrderDetailItemList(
  itemList: ReturnOrderDetailVo[],
) {
  const res: ReturnOrderDetailItem[] = []
  const returnNoMap = new Map<string, boolean>() // 用于记录退货单号是否已出现

  itemList.forEach((detail, index) => {
    const returnNo = detail.returnOrderNo ?? ''
    const isFirst = !returnNoMap.has(returnNo)

    if (isFirst) {
      returnNoMap.set(returnNo, true)
    }

    res.push({
      [FRONT_KEY]: generateUUID(),
      id: detail.returnOrderId,
      hideCheckbox: !isFirst,
      orderNo: isFirst ? (detail.orderNo ?? '') : undefined,
      returnNo: isFirst ? returnNo : undefined,
      titleOfTheContract: isFirst ? detail.titleOfTheContract : undefined,
      titleOfTheContractName: isFirst ? detail.titleOfTheContract : undefined,
      returnTime: isFirst ? detail.returnTime : undefined,
      taxRate: detail.taxRate,
      productCode: detail.productCode || '',
      productName: detail.productName || '',
      manuCode: detail.model || '',
      productPrice: detail.price,
      returnNum: detail.returnNum,
      totalAmountIncludingTax: detail.totalAmountIncludingTax,
      totalAmount: detail.totalAmount,
      totalTaxAmount: detail.totalTaxAmount,
    })
  })

  return res
}
